const isSingleRowItem = (asset) => {
  return 'videoType' in asset || parseInt(asset.orientation, 10) === 2
}

export default isSingleRowItem;
